const MSWordIcon = () => (
  <svg xmlns='http://www.w3.org/2000/svg' width='14' height='14' fill='none' viewBox='0 0 14 14'>
    <g clipPath='url(#clip0_478_685)'>
      <path
        fill='#41A5EE'
        d='M13.403.583h-9.55a.59.59 0 0 0-.597.588v2.62L8.79 5.396 14 3.79v-2.62a.59.59 0 0 0-.597-.588'
      />
      <path fill='#2B7CD3' d='M14 3.792H3.256V7l5.535.963L14 7z' />
      <path fill='#185ABD' d='M3.256 7v3.208l5.21.642L14 10.208V7z' />
      <path
        fill='#103F91'
        d='M3.853 13.416h9.55c.33 0 .597-.263.597-.588v-2.62H3.256v2.62c0 .325.267.588.597.588'
      />
      <path
        fill='#000'
        d='M7.217 3.15H3.256v8.021h3.961a.594.594 0 0 0 .597-.588V3.738a.594.594 0 0 0-.597-.588'
        opacity='0.1'
      />
      <path
        fill='#000'
        d='M6.892 3.47H3.256v8.022h3.636a.594.594 0 0 0 .596-.589V4.06a.594.594 0 0 0-.596-.588'
        opacity='0.2'
      />
      <path
        fill='#000'
        d='M6.892 3.47H3.256v7.38h3.636a.595.595 0 0 0 .596-.588V4.059a.594.594 0 0 0-.596-.588'
        opacity='0.2'
      />
      <path
        fill='#000'
        d='M6.566 3.47h-3.31v7.38h3.31a.595.595 0 0 0 .597-.588V4.059a.594.594 0 0 0-.597-.588'
        opacity='0.2'
      />
      <path
        fill='url(#paint0_linear_478_685)'
        d='M.597 3.47h5.969c.33 0 .597.264.597.589V9.94a.59.59 0 0 1-.597.588H.596A.59.59 0 0 1 0 9.941V4.059c0-.325.267-.588.597-.588'
      />
      <path
        fill='#fff'
        d='M2.449 7.98q.018.137.023.238h.014q.008-.096.032-.232l.045-.23.628-2.668h.811l.651 2.629q.057.245.081.496h.011a4 4 0 0 1 .068-.481l.52-2.645h.738L5.159 8.91h-.863l-.62-2.532a6 6 0 0 1-.102-.542h-.01a7.189 7.189 0 0 1-.092.55L2.89 8.91h-.878l-.917-3.823h.752l.565 2.674q.02.083.037.219'
      />
    </g>
    <defs>
      <linearGradient
        id='paint0_linear_478_685'
        x1='1.244'
        x2='5.816'
        y1='3.011'
        y2='11.047'
        gradientUnits='userSpaceOnUse'
      >
        <stop stopColor='#2368C4' />
        <stop offset='0.5' stopColor='#1A5DBE' />
        <stop offset='1' stopColor='#1146AC' />
      </linearGradient>
      <clipPath id='clip0_478_685'>
        <path fill='#fff' d='M0 0h14v14H0z' />
      </clipPath>
    </defs>
  </svg>
);

export default MSWordIcon;
